import { render } from "./IndexHome.vue?vue&type=template&id=8bb2e760"
import script from "./IndexHome.vue?vue&type=script&lang=js"
export * from "./IndexHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__